import React, { useState } from 'react';
import { connect } from 'react-redux';

import { setFieldError, setNewForm } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputDate from 'apps/auth/components/form/InputDate';
import { getDateForServer } from 'apps/auth/components/ga/activity/utils';
import { SELECT_PERIOD } from 'apps/auth/constants/Constants';
import { END_DATE, START_DATE } from 'apps/auth/constants/fieldsName';
import { GA_ACTIVITY } from 'apps/auth/constants/formName';
import { getIsoDate, resolveArguments } from 'apps/auth/helpers/utils';

const SelectPeriodScreen = (props) => {
    const formName = GA_ACTIVITY;
    const todayMs = Date.parse(new Date());
    const accountDateMs = props.createdDate ? Date.parse(getIsoDate(props.createdDate)) : 0;
    const [startDateMs, setStartDateMs] = useState();
    const [endDateMs, setEndDateMs] = useState();

    const formHasErrors =
        props.fields[START_DATE].isError || !props.fields[START_DATE].value || props.fields[END_DATE].isError || !props.fields[END_DATE].value;

    const onStartDateBlur = (value, name) => {
        const startDate = Date.parse(getIsoDate(value));
        if (startDate > todayMs) {
            props.setFieldError(formName, name, props.dateInFutureError);
        } else if (endDateMs && startDate > endDateMs) {
            props.setFieldError(formName, name, props.startAfterEndError);
        } else if (accountDateMs && startDate < accountDateMs) {
            const errorMessage = resolveArguments(props.beforeAccountDateError, props.createdDate);
            props.setFieldError(formName, name, errorMessage);
        }
        setStartDateMs(startDate);
    };

    const onEndDateBlur = (value, name) => {
        const endDate = Date.parse(getIsoDate(value));
        if (endDate > todayMs) {
            props.setFieldError(formName, name, props.dateInFutureError);
        } else if (startDateMs && endDate < startDateMs) {
            props.setFieldError(formName, name, props.endBeforeStartError);
        } else if (accountDateMs && endDate < accountDateMs) {
            const errorMessage = resolveArguments(props.beforeAccountDateError, props.createdDate);
            props.setFieldError(formName, name, errorMessage);
        }
        setEndDateMs(endDate);
    };

    return (
        <>
            <HeaderPanel title={props.selectPeriodTitle} />
            <Row indent="adaptive-32-48">
                <InputDate field={props.fields[START_DATE]} onBlurHandler={onStartDateBlur} isClearErrorOnFocus={true} formName={formName} isNewInput />
            </Row>
            <Row>
                <InputDate field={props.fields[END_DATE]} onBlurHandler={onEndDateBlur} isClearErrorOnFocus={true} formName={formName} isNewInput />
            </Row>
            <FixedBottomPanel>
                <Button
                    type="button"
                    raised={true}
                    onClick={() => props.requestToServerStatement(getDateForServer(SELECT_PERIOD, props.fields))}
                    disabled={formHasErrors}
                    caption={props.continue}
                />
            </FixedBottomPanel>
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        selectPeriodTitle: state.messages.pageMessages.selectPeriodTitle,
        continue: state.messages.pageMessages.continue,
        fields: state.form[GA_ACTIVITY]?.fields,
        dateInFutureError: state.messages.jsMessages['site.balance.account.statement.date.in.future.error'],
        startAfterEndError: state.messages.jsMessages['site.balance.account.statement.start.date.after.end.error'],
        endBeforeStartError: state.messages.jsMessages['site.balance.account.statement.end.date.before.start.error'],
        beforeAccountDateError: state.messages.jsMessages['site.balance.account.statement.date.earlier.error'],
        createdDate: state.extra.createdDate,
    };
};
const mapDispatchToProps = {
    setNewForm,
    setFieldError,
};
export default connect(mapStateToProps, mapDispatchToProps)(SelectPeriodScreen);
